export default {
    dialogRoot: {
        flex: '0 1 auto',
    },
    dialogAction: {},
};
